module.exports = __webpack_public_path__ + "img/emoji_08.7d15bd9e.png";